import { FileCopyOutlined, QrCode2 } from "@mui/icons-material";
import {
  Avatar,
  Card,
  CardContent,
  Container,
  IconButton,
  Snackbar,
  Stack,
  Typography
} from "@mui/joy";
import * as React from "react";
import CopyToClipboard from "react-copy-to-clipboard";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import HeaderBackButton from "../components/HeaderBackButton";
import styles from "../components/RecieveCard.module.css";

export default function Receive() {
  const walletData = useSelector((state) => state.walletsData);

  return (
    <>
      <HeaderBackButton title={"Receive crypto"} />
      <Container maxWidth="md">
        <Stack spacing={2}>
          {walletData.map((coin, index) => (
            <ReceiveCard coin={coin} key={index} />
          ))}
        </Stack>
      </Container>
    </>
  );
}

export const ReceiveCard = ({ coin }) => {
  const navigate = useNavigate();

  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const { coinname, image, address } = coin;

  return (
    <>
      <Card variant="outlined">
        <CardContent>
          <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
            <Stack direction={"column"} spacing={1}>
              <Typography level="title-md">Your {coinname} address</Typography>
              <div className={styles.mkz6qaujb5nsymzcyzarctrecc2a3h}>
                <Typography level="body-md" noWrap={true}>
                  {address}
                </Typography>
              </div>
              <Avatar variant="outlined" size="sm" src={image} />
            </Stack>

            <Stack direction={"row"} spacing={1} height={"fit-content"}>
              <IconButton
                size="md"
                variant="outlined"
                sx={{ borderRadius: 50 }}
                onClick={() => navigate("/receive/coin", { state: coin })}
              >
                <QrCode2 />
              </IconButton>

              <CopyToClipboard text={address} onCopy={() => setOpen(true)}>
                <IconButton
                  size="md"
                  variant="outlined"
                  sx={{ borderRadius: 50 }}
                >
                  <FileCopyOutlined />
                </IconButton>
              </CopyToClipboard>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
      <Snackbar
        color="success"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={open}
        onClose={handleClose}
      >
        Address copied
      </Snackbar>
    </>
  );
};
